<template>
  <div style="clear:both;">
    <v-card>
      <v-container fluid>
        <v-row dense>
          <v-col cols="12" sm="10">
            <v-textarea
              :label="$t('Closer_Denied_Reason')"
              name="reason"
              :model-value="closerDeniedReasonText"
              auto-grow
              rows="1"
              variant="underlined"
              readonly
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="6">
            <people-picker
              :label="$t('Closer_Denied_By')"
              readonly
              :user="closerDeniedUser"
              :inUser="closerDeniedUser"
            ></people-picker>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field dense variant="underlined" :value="$filters.DateTimeFilter(closerDeniedDateValue)" readonly></v-text-field>
          </v-col>
        </v-row>

        <template v-if="closerDeniedHistoryLog.length > 0">
          <v-row>
            <v-col cols="12">{{ 'History' }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="closerDeniedHistoryLog"
                class="elevation-1"
                :footer-props="pagination"
                :options.sync="options"
                :sort-by="options.sortBy"
                :sort-desc="options.descending"
              >
                <template v-slot:item="props">
                  <tr>
                    <td>
                      <v-textarea variant="underlined" auto-grow readonly :rows="1" :value="props.item.reason"></v-textarea>
                    </td>
                    <td>{{ closerDeniedUserDisplayName(props.item.closerDeniedBy) }}</td>
                    <td>{{ $filters.DateTimeFilter(props.item.closerDeniedDate) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
export default {
  data() {
    return {
      pagination: {
        'items-per-page-options': [10, 20, 30, 40]
      },
      options: {
        itemsPerPage: 20,
        sortBy: ['closerDeniedDate'],
        descending: true
      },
      headers: [
        {
          title: this.$t('Closer_Denied_Reason'),
          align: 'left',
          key: 'reason'
        },
        { title: this.$t('Closer_Denied_By'), key: 'closerDeniedBy' },
        { title: this.$t('Closer_Denied_Date'), key: 'closerDeniedate' }
      ]
    }
  },
  props: {
    closerDeniedReason: {
      type: Object,
      default: null
    },
    roles: {
      type: Array,
      default: null
    },
    mocFormStatus: {
      type: String
    },
    closerDeniedHistory: {
      type: Array,
      default: null
    }
  },
  components: {
    PeoplePicker
  },
  methods: {
    closerDeniedUserDisplayName: function(user) {
      return user ? user.displayName : ''
    }
  },
  computed: {
    closerDeniedUser: function() {
      if (this.closerDeniedReason) {
        if (this.closerDeniedReason.closerDeniedBy) {
          return this.closerDeniedReason.closerDeniedBy
        }
      }
      return null
    },
    closerDeniedReasonText: function() {
      if (this.closerDeniedReason) {
        return this.closerDeniedReason.reason
      } else {
        return ''
      }
    },
    closerDeniedDateValue: function() {
      if (this.closerDeniedReason) {
        return this.closerDeniedReason.closerDeniedDate
      } else {
        return null
      }
    },
    closerDeniedHistoryLog: function() {
      if (this.closerDeniedHistory) {
        if (this.closerDeniedHistory.length > 1) {
          return this.closerDeniedHistory.slice(0, this.closerDeniedHistory.length - 1)
        }
      }
      return []
    }
  }
}
</script>

<style scoped></style>
